// extracted by mini-css-extract-plugin
export default {"wrapper":"UserPreferences_wrapper__c4T7j","menu":"UserPreferences_menu__ckwgX"};